/* eslint-disable import/no-anonymous-default-export */
import { Tabs } from "antd";
import MainLayout from "../../common/components/MainLayout";
import LotesRenombradoAsignacion from "../components/LotesRenombradoAsignacion";
import ResumenRenombrado from "../components/ResumenRenombrado";

export default () => {
    return (
        <MainLayout>
            <Tabs
                defaultActiveKey="lotes"
                items={[
                    {
                        key: "lotes",
                        label: "Lotes",
                        children: <LotesRenombradoAsignacion />
                    },
                    {
                        key: "resumen",
                        label: "Resumen",
                        children: <ResumenRenombrado />
                    }
                ]}
            />
        </MainLayout>
    );
};
